import * as _ from 'lodash';
import * as gettextparser from 'gettext-parser';
import type { GetTextTranslation } from 'gettext-parser';

export interface GetTextTranslations
  extends gettextparser.GetTextTranslations {}

export function parsePoFile(content: string) {
  return gettextparser.po.parse(content);
}

export function mergeTranslationsIn(
  target: GetTextTranslations,
  ...sources: GetTextTranslations[]
): GetTextTranslations {
  function setIn(
    msgctxt: string,
    msgId: string,
    translation: GetTextTranslation
  ) {
    _.set(target, [msgctxt, msgId], translation);
  }

  for (let source of sources) {
    for (let [msgctxt, messages] of Object.entries(source.translations)) {
      for (let [msgId, translation] of Object.entries(messages)) {
        setIn(msgctxt, msgId, translation);
      }
    }
  }

  return target;
}

export function getTranslationsLanguage(trans: GetTextTranslations) {
  let result: string = trans.headers['Language'];
  if (!result) {
    throw new Error('Missing language header in translation.');
  }

  return result.split('_')[0];
}
